module.exports = __webpack_public_path__ + "assets/AngleIsosceles.f71425bb2fb3b09d3bd02d5e6b31ea69.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/AngleIsosceles.gmt
// module id = 899
// module chunks = 0